import { useQuery } from '@tanstack/react-query';
import type { ApiResponse, PricesResponse } from '@crypto-factory/shared-types';

const PROD_API = 'https://crypto-factory-api.cryptoramosv2.workers.dev';
const API_BASE = import.meta.env.VITE_API_URL || PROD_API;

/**
 * Fetches live crypto prices from the API
 */
async function fetchPrices(): Promise<PricesResponse> {
    const res = await fetch(`${API_BASE}/api/prices`);
    if (!res.ok) throw new Error('Failed to fetch prices');
    const data: ApiResponse<PricesResponse> = await res.json();
    if (!data.success) throw new Error(data.error || 'Unknown error');
    return data.data!;
}

/**
 * Hook to access live crypto prices
 */
export function usePrices() {
    const query = useQuery({
        queryKey: ['prices'],
        queryFn: fetchPrices,
        staleTime: 1000 * 30, // 30 seconds
        refetchInterval: 1000 * 60, // Refetch every minute
    });

    return {
        prices: query.data?.prices ?? [],
        cachedAt: query.data?.cachedAt,
        isLoading: query.isLoading,
        isError: query.isError,
        error: query.error,
    };
}
